import styled from 'styled-components';
import { Checkbox } from 'antd';

export const Container = styled(Checkbox)``;
export const FormCheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0px;
  }
`;
